<div class="wrapper">
  <span class="upload-photos-info" *ngIf="showUploadPhotosInfo">
    {{ 'i18n.gallery.uploadPhotos.info' | translate }}
  </span>
  <div class="thumbnails" #thumbnailsWrapper (window:resize)="onResize()">
    <ng-template ngFor let-imagesChunk
        [ngForOf]="galleryImages | paginate: {
          id: paginationId,
          itemsPerPage: 1,
          currentPage: currentPage()
        }"
    >
      <ng-template ngFor let-image [ngForOf]="imagesChunk" [ngForTrackBy]="trackById">
        <div class="thumbnail-container"
            [ngClass]="{'used': imageIsUsed(image.id),
                'selected': imageIsSelected(image.id) }">
          <img class="thumbnail"
              [ngClass]="{
                  load: loadedImages.indexOf(image) === -1,
                  loaded: loadedImages.indexOf(image) > -1
              }"
              (load)="loadedImages.push(image)"
              [attr.data-imageId]="image.id"
              [src]="getThumbnailUrl(image)"
              [style.width]="getThumbnailWidth(image)"
              [style.height]="getThumbnailHeight()"
              (dragstart)="dragStart(image.id)"
              (click)="!imageIsUsed(image.id) ? imageClicked.emit(image.id) : ''"
              />
        </div>
      </ng-template>
    </ng-template>
  </div>

  <pagination-controls  [id]="paginationId"
                        (pageChange)="pageChanged($event)"
                        maxSize="5"
                        directionLinks="true"
                        autoHide="true"
                        previousLabel=""
                        nextLabel=""
                        screenReaderPaginationLabel="Pagination"
                        screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page"
  ></pagination-controls>

  <mat-progress-bar *ngIf="progress.inProgress"
                    mode="determinate"
                    [value]="galleryService.uploadPercentage"
                    color="accent"></mat-progress-bar>
  <span *ngIf="progress.inProgress" class="upload-progress">
    <translate [key]="'i18n.gallery.uploadProgress'"
               [plural]="galleryService.imagesToUpload || 1"
               [values]="{ current: galleryService.imagesUploaded,
                           total: galleryService.imagesToUpload || 1 }"
    ></translate>
  </span>
</div>



// WEBPACK FOOTER //
// ./src/app/gallery/gallery.component.html